// https://css-tricks.com/the-trick-to-viewport-units-on-mobile

export function updateViewportValues(root) {
  root.style.setProperty('--vH', `${window.innerHeight / 100}px`)
}



// WEBPACK FOOTER //
// ./resources/js/modules/UI/viewport/index.js